import { useDynamicConfig } from '@statsig/react-bindings'
import { DynamicConfigName } from 'lib/statsig/feature_gates'
import { useAuthContext } from 'components/auth'

export function useIsTippingEnabled() {
  const { company } = useAuthContext()
  const config = useDynamicConfig(
    DynamicConfigName.EnableTipsInTheBusinessPortal
  )

  if (company?.id && config.get('company_ids', []).includes(company?.id)) {
    return true
  }

  return false
}
